import { DatePipe, JsonPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ProposalComponent } from 'src/app/components/proposal/proposal.component';
import { ConnectionService } from 'src/app/services/connection.service';
import { DataFieldsService } from 'src/app/services/data-fields.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-care-proposal-form',
  templateUrl: './care-proposal-form.page.html',
  styleUrls: ['./care-proposal-form.page.scss'],
})
export class CareProposalFormPage implements OnInit {
  btnObj = {
    proposerFilled: "section-btn active-section-btn",
    memberFilled: "section-btn",
    contactDetailsFilled: "section-btn",
    nomineeDetailFilled: "section-btn",
    contactSegment: "section-btn"
  }
  healthQuestionObj = {
    bpExistShow: false,
    ldExistShow: false,
    cancerExistShow: false,
    cardiacExistShow: false,
    jointExistShow: false,
    showKidneyDate: false,
    showParalysis: false,
    showCongentail: false,
    showHiv: false,
    showEndo: false,
    showPedEndo: false,
    showProlonged: false,
    showSmoke: false,
    showAilment: false,
    showRespiratory: false,
  }
  insurerDetails: any = [];
  respObj: any;
  careProposalForm: FormGroup;
  carePropDetailForm: FormGroup;
  careContactForm: FormGroup;
  nomineeForm: FormGroup;
  insurerList: any = [];
  partyList: any = [];
  sumInsured: any;
  abacusId: any;
  eldestAge: any;
  premium: any;
  orderId: any;
  quoteId: any;
  term: any;
  sumCode: any;
  termValue: any;
  coverType: any;
  proposalRelationFrom: FormGroup;
  agreeValue: string;
  agreeTcValue: string;
  agreeAlertValue: string;
  memAge: any;
  private _url = environment.baseUrl;
  personalInfoObj = {
    pandetail: false,
    memPandetail: false,
    mAge: 0,
    salutation: '',
    gender: '',
    genderDisBtn: false
  }
  healthConditionalObj = {
    showNominee: false,
    showSuccessMsg: false,
    showContactassuredformbtn: false,
    disableCheck: false,
    showPrpDetails: true,
    showMemDetails: false,
    isAddrSame: false,
    showPermAdd: true,
    showAddress: false,
  }
  paymentCallbackURL: string;
  proposalNumber: any;
  pinCode: any = [];
  proposerDetailObj: any = [];
  getAddOns: any;
  getAddOnsString: string;
  qustMemObj: any = [];
  upgradedQuoteResponseObj: any;
  upgradedQuoteReqObj: any;
  appIncompleteData: any;
  productName: any;
  submitFormData: any = {}
  termDetails: any;
  termData: any;
  quoteValue: any;
  careTopUpDetails: any;
  addOnOption: string;

  ckycNo: any;
  eKycRefNo: any;
  showCareOvdkycDocsUpload: boolean = false;
  careAppSubRes: any;
  addrProofFIle: any;
  addrProofPreviewUrl: string | ArrayBuffer;
  idProofFile: any;
  idProofPreviewUrl: string | ArrayBuffer;
  showIdProofCard: boolean = true;
  showAddrProofCard: boolean = true;

  constructor(private _dataFields: DataFieldsService, private _datePipe: DatePipe, private route: ActivatedRoute,
    private strg: StorageService, private fb: FormBuilder,
    private apiService: ConnectionService, private datePipe: DatePipe, private toast: ToastService,
    private loader: LoaderService, private modalCtrl: ModalController) {
  }

  ngOnInit() {
    this.paymentCallbackURL = `${this._url}/user/public/insurance/care/paymentCallbackUrl`
    this.insurerDetails = this._dataFields.getInsurerList()
    this.careProposalForm = this.fb.group({
      proposalInfo: new FormArray([])
    })
    this.proposalRelationFrom = this.fb.group({
      cpf_isPropser: ['', [Validators.required]],
    })
    this.carePropDetailForm = this.fb.group({
      cpf_prpSalutation: ['', [Validators.required]],
      cpf_prpFName: ['', [Validators.required]],
      cpf_prpLName: ['', [Validators.required]],
      cpf_prpDob: ['', [Validators.required, dobValidate]],
      cpf_prpGender: ['', [Validators.required]],
      cpf_prpRelation: ['', [Validators.required]],
      cpf_prpHeight: [''],
      cpf_prpWeight: [''],
      cpf_prpIdtype: [''],
      cpf_prpIdNumber: ['', [Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")]],
    })
    this.careContactForm = this.fb.group({
      cpf_Houseno: ['', [Validators.required, Validators.pattern(/^[\w&,.\-#/ ]*$/)]],
      cpf_Street: ['', [Validators.required, Validators.pattern(/^[\w&,.\-#/ ]*$/)]],
      cpf_Landmark: ['', [Validators.required, Validators.pattern(/^[\w&,.\-#/ ]*$/)]],
      cpf_City: ['', [Validators.required]],
      cpf_State: ['', [Validators.required]],
      cpf_Pincode: ['', [Validators.required, Validators.pattern('^[1-9][0-9]{5}$')]],
      cpf_Country: ['', [Validators.required]],
      cpf_CorHous: ['', Validators.pattern(/^[\w&,.\-#/ ]*$/)],
      cpf_CorStreet: ['', Validators.pattern(/^[\w&,.\-#/ ]*$/)],
      cpf_CorLand: ['', Validators.pattern(/^[\w&,.\-#/ ]*$/)],
      cpf_corCity: [''],
      cpf_CorState: [''],
      cpf_CorPincode: ['', [Validators.pattern('^[1-9][0-9]{5}$')]],
      cpf_CorCount: [''],
      cpf_contactNo: ['', [Validators.required, Validators.pattern('[6-9]\\d{9}')]],
      cpf_Email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]],
    })
    this.nomineeForm = this.fb.group({
      cpf_nomineeRelation: ['', [Validators.required]],
      cpf_nomineeName: ['', [Validators.required]],
      cpf_Tc: [false, [Validators.required, Validators.pattern('true')]],
      cpf_AgAlert: [false, [Validators.required, Validators.pattern('true')]]
    })
  }
  get care() { return this.careProposalForm.controls; }

  get propInfor() { return this.care.proposalInfo as FormArray }

  showSposeProp: boolean = true;

  ionViewDidEnter() {
    this.route.params.subscribe(
      (params) => {
        let productName = String(params.productName)
        console.log(productName)
        if (productName === 'enhnace1Floater' || productName === 'enhnace1Individual') {
          this.productName = "Enhance 1"
        }
      }
    );

    this.route.queryParams.subscribe(
      (params) => {
        let requestId = String(params.requestId);
        let status = String(params.status);
        console.log("sdsdsdsdsderererererererer", requestId, status);
        if (requestId && status === "success") {
          console.log("success ekyc!!!!");
          this.apiService.fetchCareEkycDetails(requestId).subscribe(res => {
            console.log("care ekyc res", res);
            this.autoFillEKYCDetails(res.data.eadharDetailsIO);
          }, err => {
            console.log("error", err)
          })
        } else if (requestId && status === "failure") {
          console.log("failure ekyc!!!!")
        }
      }
    );
    this.apiService.healthQuoteListArray.subscribe(quoteList => {
      if (quoteList.length > 0 && quoteList[0].addOns === true) {
        this.addOnOption = "EXPERTOPNENH1"
      }
      else {
        this.addOnOption = null
      }
    })
    this.strg.getStoreData('hlIncp').then(res => {
      if (res) {
        console.log("oooooodvdvdvdvdvdvd 1")
        this.strg.getStoreData("careOvdKyc").then(ress => {
          console.log("oooooodvdvdvdvdvdvd 2")
          if (ress === "true") {
            console.log("oooooodvdvdvdvdvdvd 3")
            this.strg.getStoreData('careHealthBasicResData').then(resss => {
              this.careAppSubRes = resss;
              this.proposalNumber = this.careAppSubRes.intPolicyDataIO.policy.proposalNum;
              console.log("oooooodvdvdvdvdvdvd 4", this.careAppSubRes)
              this.showCareOvdkycDocsUpload = true;
            })
          } else {
            this.getIncompleteApplication();
          }
        })
      }
      else {
        this.getQuoteResId()
        //todo handling
      }
    })
  }

  autoFillEKYCDetails(data) {
    console.log("auto fill ekyc details");
    this.eKycRefNo = data.essentials?.requestId;
    let nameSplit = data.name.split(" ");
    this.carePropDetailForm.get("cpf_prpSalutation").setValue(data.gender === 'MALE' ? 'MR' : 'MS');
    this.carePropDetailForm.get("cpf_prpFName").setValue(nameSplit[0].length === 1 ? nameSplit[0] + " " : nameSplit[0]);
    nameSplit.shift();
    nameSplit.join(" ");
    console.log("dfdfdf", nameSplit);
    this.carePropDetailForm.get("cpf_prpLName").setValue(nameSplit.length === 1 ? " " + nameSplit : nameSplit);
    console.log("lname", nameSplit);
    this.carePropDetailForm.get("cpf_prpGender").setValue(data.gender);
    let dobSplit = (data.dob).split("/");
    this.carePropDetailForm.get("cpf_prpDob").patchValue(dobSplit[2] + "-" + dobSplit[1] + "-" + dobSplit[0]);
    this.careContactForm.get('cpf_Pincode').setValue(data.pincode);
    this.getPermPincodeDetails();
  }

  autoFillCKYCDetails() {
    console.log("hii hii hii")
    this.strg.getStoreData('careCkyc').then(res => {
      console.log("res personalDetails", res);
      if (res?.personalDetails) {
        let personalDetails = res.personalDetails;
        this.ckycNo = personalDetails.ckycNo;

        this.carePropDetailForm.get("cpf_prpSalutation").setValue(personalDetails.gender === "MALE" || personalDetails.gender === "M" ? "MR" : "MS");
        this.carePropDetailForm.get("cpf_prpFName").setValue(personalDetails.firstName);
        if (personalDetails?.middleName) {
          this.carePropDetailForm.get("cpf_prpLName").setValue(personalDetails.middleName.length === 1 ? " " + personalDetails.middleName : personalDetails.middleName);
        } else {
          this.carePropDetailForm.get("cpf_prpLName").setValue(personalDetails.lastName.length === 1 ? " " + personalDetails.lastName : personalDetails.lastName);
        }
        let dobSplit = (personalDetails.dob).split("-");
        this.carePropDetailForm.get("cpf_prpDob").patchValue(dobSplit[2] + "-" + dobSplit[1] + "-" + dobSplit[0]);
        if (personalDetails.gender === "M") {
          this.carePropDetailForm.get("cpf_prpGender").setValue("MALE");
        } else if (personalDetails.gender === "F") {
          this.carePropDetailForm.get("cpf_prpGender").setValue("FEMALE");
        } else {
          this.carePropDetailForm.get("cpf_prpGender").setValue(personalDetails.gender);
        }
        this.careContactForm.get('cpf_Pincode').setValue(personalDetails.permPin);
        this.getPermPincodeDetails();
      }
    })
  }

  getIncompleteApplication() {
    this.loader.showLoader();
    this.apiService.getIncompleteICICIAppData().subscribe(res => {
      console.log('this.productName', this.productName)
      console.log('res', res)
      this.loader.hideLoader();
      this.careTopUpDetails = JSON.parse(res.data[0].insuranceOrderHistory.insuranceQuoteResponse.responseParam)
      console.log(this.careTopUpDetails)
      this.quoteValue = this.careTopUpDetails
      this.propInfor.clear()
      if (this.productName === 'Enhance 1') {
        console.log("Enhance 1 product is available 1")
        this.carePropDetailForm.get('cpf_prpHeight').setValidators(Validators.required);
        this.carePropDetailForm.get('cpf_prpHeight').updateValueAndValidity();
        this.carePropDetailForm.get('cpf_prpWeight').setValidators(Validators.required);
        this.carePropDetailForm.get('cpf_prpWeight').updateValueAndValidity();
        console.log('this.careTopUpDetails bakjsdh aksdjhakdshakjhsd', this.careTopUpDetails)
        if (this.careTopUpDetails.inputFields[7].selectedValue === '1 Year' || this.careTopUpDetails.inputFields[7].selectedValue === '1') {
          this.termData = 1
        }
        else if (this.careTopUpDetails.inputFields[7].selectedValue === '2 Year' || this.careTopUpDetails.inputFields[7].selectedValue === '2') {
          this.termData = 2
        }
        else if (this.careTopUpDetails.inputFields[7].selectedValue === '3 Year' || this.careTopUpDetails.inputFields[7].selectedValue === '3') {
          this.termData = 3
        }
        let careReqData = JSON.parse(res.data[0].insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.reqParam)
        this.abacusId = this.careTopUpDetails.abacusData.abacusId;
        this.premium = this.careTopUpDetails.outputFields.find(item => item.fieldName === "field_8").premium;
        this.eldestAge = this.careTopUpDetails.inputFields.find(item => item.fieldName == "field_3").selectedValue;
        this.coverType = this.careTopUpDetails.inputFields.find(item => item.fieldName == "field_9").selectedValue === 'Individual' ? 'INDIVIDUAL' : 'FAMILYFLOATER';
        this.sumInsured = this.careTopUpDetails.inputFields.find(item => item.fieldName == "field_2").selectedValueCode;
        this.respObj = careReqData.reqParam.membersArray
        this.respObj.forEach(element => {
          if (element.memberType === 'Son' || element.memberType === "Father" || element.memberType === "Grand-Father" || element.memberType === "Father-in-Law" || element.memberType === "Brother" || element.memberType === "GrandSon" || element.memberType === "Uncle" || element.memberType === "Nephew") {
            this.personalInfoObj.salutation = 'MR';
            this.personalInfoObj.gender = "MALE"
            this.personalInfoObj.genderDisBtn = true;
          }
          else if (element.memberType === 'Daughter' || element.memberType === "Mother" || element.memberType === "Grand-Mother" || element.memberType === "Mother-in-Law" || element.memberType === "Sister" || element.memberType === "GrandDaughter" || element.memberType === "Niece") {
            this.personalInfoObj.salutation = 'MS';
            this.personalInfoObj.gender = "FEMALE";
            this.personalInfoObj.genderDisBtn = true
          }
          else {
            this.personalInfoObj.salutation = '';
            this.personalInfoObj.gender = "";
            this.personalInfoObj.genderDisBtn = false;
          }
          let customValidate;
          if (element.memberType === 'Son' || element.memberType === 'Daughter' || element.memberType === "GrandSon" || element.memberType === "GrandDaughter" || element.memberType === "Nephew" || element.memberType === "Niece") {
            customValidate = dobValidate2;
          } else {
            customValidate = dobValidate;
          }
          if (element.memberType === 'Self') {
            element.value = 'SELF'
          }
          else if (element.memberType === 'Spouse') {
            element.value = 'SPSE'
          }
          else if (element.memberType === 'Son') {
            element.value = 'SONM'
          }
          else if (element.memberType === 'Daughter') {
            element.value = 'UDTR'
          }
          else if (element.memberType === 'Father') {
            element.value = 'FATH'
          }
          else if (element.memberType === 'Mother') {
            element.value = 'MOTH'
          }
          else if (element.memberType === 'Brother') {
            element.value = 'BOTH'
          }
          else if (element.memberType === 'Sister') {
            element.value = 'SIST'
          }
          else if (element.memberType === 'GrandSon') {
            element.value = 'GSON'
          }
          else if (element.memberType === 'GrandDaughter') {
            element.value = 'GDAU'
          }
          else if (element.memberType === 'Uncle') {
            element.value = 'MUNC'
          }
          else if (element.memberType === 'Newphew') {
            element.value = 'NEPH'
          }
          else if (element.memberType === 'Niece') {
            element.value = 'NIEC'
          }
          else if (element.memberType === 'Grand-Mother') {
            element.value = 'GMOT'
          }
          else if (element.memberType === 'Grand-Father') {
            element.value = 'GFAT'
          }
          else if (element.memberType === 'Mother-in-Law') {
            element.value = 'MLAW'
          }
          else if (element.memberType === 'Father-in-Law') {
            element.value = 'FLAW'
          }
          console.log(this.propInfor)
          this.propInfor.push(this.fb.group({
            // cpf_click: [this.clickFunction],
            cpf_relName: [element.memberType],
            cpf_title: [this.personalInfoObj.salutation, [Validators.required]],
            cpf_fName: ['', [Validators.required]],
            cpf_lName: ['', [Validators.required]],
            cpf_Dob: ['', [Validators.required, customValidate]],
            cpf_gender: [this.personalInfoObj.gender, [Validators.required]],
            cpf_Relation: [element.value, [Validators.required]],
            cpf_Idtype: [''],
            cpf_idNumber: ['', Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")],
            cpf_height: [''],
            cpf_weight: [''],
            cpf_diabeties: ['', Validators.required],
            cpf_DiabDate: [''],
            cpf_bp: ['', Validators.required],
            cpf_bpDate: [''],
            cpf_ld: ['', Validators.required],
            cpf_ldDate: [''],
            cpf_Cancer: ['', Validators.required],
            cpf_CancerDate: [''],
            cpf_Cardiac: ['', Validators.required],
            cpf_CardiacDate: [''],
            cpf_jPoint: ['', Validators.required],
            cpf_jpDate: [''],
            cpf_kDisease: ['', Validators.required],
            cpf_kDiseaseDate: [''],
            cpf_paralysis: ['', Validators.required],
            cpf_paralysisDate: [''],
            // cpf_cdisorder: ['', Validators.required],// commented for congenital que issue
            // cpf_cdisorderDate: [''],
            cpf_hiv: ['', Validators.required],
            cpf_hivDate: [''],
            cpf_preExitinsurer: ['', Validators.required],
            cpf_clcpInsurer: ['', Validators.required],
            cpf_pedillnessDetails: ['', Validators.required],
            cpf_hiDec: ['', Validators.required],
            cpf_alreadyCovered: ['', Validators.required],
            cpf_hospFor: ['', Validators.required],
            cpf_pedOtherDisease: ['', Validators.required],
            cpf_OtherAilmExistingDate: [''],
            cpf_ailmentDesc: [''],
            cpf_pedRespDetail: ['', Validators.required],
            cpf_respExistingDate: [''],
            cpf_pedEndoDetails: ['', Validators.required],
            cpf_EndCrineExistingDate: [''],
            cpf_piExistingDate: [''],
            cpf_PrillExisting: [''],
            cpf_smokeDetails: ['', Validators.required],
            cpf_smokeExisting: [''],
            cpf_smokeDesc: [''],
            cpf_prolongedDetails: ['', Validators.required],
            cpf_prolongedExisting: [''],
          }))
          if (this.respObj.length === 1 && element.value === 'SELF') {
            this.carePropDetailForm.get('cpf_prpRelation').setValue('SELF')
          }
          else {
            this.carePropDetailForm.get('cpf_prpRelation').setValue('SELF')
          }
        });
        if (this.premium.replace(/,/g, '') >= 50000) {
          this.personalInfoObj.pandetail = true;
        }
        else if (this.premium.replace(/,/g, '') < 50000) {
          this.personalInfoObj.pandetail = false;
        }

        else {
          this.abacusId = this.careTopUpDetails.abacusData.abacusId;
        }
      }
      else if (this.productName != 'Enhance 1') {
        this.abacusId = this.careTopUpDetails.careQuoteResponse.responseParam.abacusData.abacusId;
        this.premium = this.careTopUpDetails.careQuoteResponse.responseParam.outputFields.find(item => item.fieldName === "field_8")?.premium;
        this.eldestAge = this.careTopUpDetails.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_3").selectedValue;
        let termDetails = this.careTopUpDetails.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_4");
        this.termValue = Number(termDetails.selectedValue.substring(0, termDetails.selectedValue.length - 5).trim());
        this.coverType = this.careTopUpDetails.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_9").selectedValue === 'Individual' ? 'INDIVIDUAL' : 'FAMILYFLOATER';
        this.sumInsured = this.careTopUpDetails.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_2").selectedValue;
        this.sumCode = this.careTopUpDetails.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_2").selectedValueCode;
        this.respObj = this.careTopUpDetails.careQuoteRequest.reqParam.insurer;
        console.log('this.productName != Enhance 1', this.propInfor)
        console.log('this.productName != Enhance 2', this.respObj)
        this.respObj.forEach(element => {
          if (element.name === 'Son' || element.name === "Father" || element.name === "Grand-Father" || element.name === "Father-in-Law" || element.name === "Brother" || element.name === "GrandSon" || element.name === "Uncle" || element.name === "Nephew") {
            this.personalInfoObj.salutation = 'MR';
            this.personalInfoObj.gender = "MALE"
            this.personalInfoObj.genderDisBtn = true;
          }
          else if (element.name === 'Daughter' || element.name === "Mother" || element.name === "Grand-Mother" || element.name === "Mother-in-Law" || element.name === "Sister" || element.name === "GrandDaughter" || element.name === "Niece") {
            this.personalInfoObj.salutation = 'MS';
            this.personalInfoObj.gender = "FEMALE";
            this.personalInfoObj.genderDisBtn = true
          }
          else {
            this.personalInfoObj.salutation = '';
            this.personalInfoObj.gender = "";
            this.personalInfoObj.genderDisBtn = false;
          }
          let customValidate;
          if (element.name === 'Son' || element.name === 'Daughter' || element.name === "GrandSon" || element.name === "GrandDaughter" || element.name === "Nephew" || element.name === "Niece") {
            customValidate = dobValidate2;
          } else {
            customValidate = dobValidate;
          }
          this.propInfor.push(this.fb.group({
            // cpf_click: [this.clickFunction],
            cpf_relName: [element.name],
            cpf_title: [this.personalInfoObj.salutation, [Validators.required]],
            cpf_fName: ['', [Validators.required]],
            cpf_lName: ['', [Validators.required]],
            cpf_Dob: ['', [Validators.required, customValidate]],
            cpf_gender: [this.personalInfoObj.gender, [Validators.required]],
            cpf_Relation: [element.value, [Validators.required]],
            cpf_Idtype: [''],
            cpf_idNumber: ['', Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")],
            cpf_diabeties: ['', Validators.required],
            cpf_DiabDate: [''],
            cpf_bp: ['', Validators.required],
            cpf_bpDate: [''],
            cpf_ld: ['', Validators.required],
            cpf_ldDate: [''],
            cpf_Cancer: ['', Validators.required],
            cpf_CancerDate: [''],
            cpf_Cardiac: ['', Validators.required],
            cpf_CardiacDate: [''],
            cpf_jPoint: ['', Validators.required],
            cpf_jpDate: [''],
            cpf_kDisease: ['', Validators.required],
            cpf_kDiseaseDate: [''],
            cpf_paralysis: ['', Validators.required],
            cpf_paralysisDate: [''],
            // cpf_cdisorder: ['', Validators.required],// commented for congenital que issue
            // cpf_cdisorderDate: [''],
            cpf_hiv: ['', Validators.required],
            cpf_hivDate: [''],
            cpf_preExitinsurer: ['', Validators.required],
            cpf_clcpInsurer: ['', Validators.required],
            cpf_pedillnessDetails: ['', Validators.required],
            cpf_hiDec: ['', Validators.required],
            cpf_alreadyCovered: ['', Validators.required],
            cpf_hospFor: ['', Validators.required],
            cpf_pedOtherDisease: ['', Validators.required],
            cpf_OtherAilmExistingDate: [''],
            cpf_ailmentDesc: [''],
            cpf_pedRespDetail: ['', Validators.required],
            cpf_respExistingDate: [''],
            cpf_pedEndoDetails: ['', Validators.required],
            cpf_EndCrineExistingDate: [''],
            cpf_piExistingDate: [''],
            cpf_PrillExisting: [''],
            cpf_smokeDetails: ['', Validators.required],
            cpf_smokeExisting: [''],
            cpf_smokeDesc: [''],
            cpf_prolongedDetails: ['', Validators.required],
            cpf_prolongedExisting: [''],
          }))
          if (this.respObj.length === 1 && element.value === 'SELF') {
            this.carePropDetailForm.get('cpf_prpRelation').setValue('SELF')
          }
          else {
            this.carePropDetailForm.get('cpf_prpRelation').setValue(null)
          }
        });
      }
      if (res) {
        if (res.data.length != 0) {
          let data = res.data;
          data = data[0];
          this.orderId = data.insuranceOrderHistory.id;
          this.quoteId = data.insuranceOrderHistory.insuranceQuoteResponse.id
          this.upgradedQuoteResponseObj = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam);
          this.upgradedQuoteReqObj = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.reqParam);
          this.appIncompleteData = JSON.parse(data.parameter);
          this.autoFillFormData(this.appIncompleteData);
        }
        else {
          this.getQuoteResId();
        }
      }
    }, err => {
      this.loader.hideLoader();
    });
  }

  autoFillFormData(autoFillData) {
    if (autoFillData.careProposerDetails) {
      this.carePropDetailForm.setValue(autoFillData.careProposerDetails)
    }
    if (autoFillData.careInsurerDetails) {
      console.log('autoFillData.careInsurerDetails.proposalInfo', autoFillData.careInsurerDetails.proposalInfo)
      this.propInfor.setValue(autoFillData.careInsurerDetails.proposalInfo)
    }
    if (autoFillData.careContactDetails) {
      this.careContactForm.setValue(autoFillData.careContactDetails)
    }
    if (autoFillData.careNomineeDetails) {
      this.nomineeForm.setValue(autoFillData.careNomineeDetails)
      this.agreeTcValue = this.nomineeForm.get('cpf_Tc').value === true ? "YES" : "NO"
      this.agreeAlertValue = this.nomineeForm.get('cpf_AgAlert').value === true ? "YES" : "NO"
    }
    this.autoFillCKYCDetails();
  }
  toShowIdDetails(e, i) {
    this.memAge = new Date(e.target.value)
    var timeDiff = Math.abs(Date.now() - this.memAge);
    this.personalInfoObj.mAge = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    if (this.premium.replace(/,/g, '') >= 50000 && this.coverType === 'INDIVIDUAL' && this.personalInfoObj.mAge >= 18) {
      this.personalInfoObj.memPandetail = true;
      this.propInfor[i].controls.cpf_Idtype.setValidators(Validators.required)
      this.propInfor[i].controls.cpf_idNumber.setValidators(Validators.required)
      this.propInfor[i].controls.cpf_idNumber.setValidators(Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$"))
    } else if (this.premium.replace(/,/g, '') < 50000 && this.personalInfoObj.mAge < 18) {
      this.personalInfoObj.memPandetail = false;
      this.propInfor[i].controls.cpf_Idtype.clearValidators()
      this.propInfor[i].controls.cpf_idNumber.clearValidators()
    }
  }
  indexff: any;
  accordionClick(i) {
    if (i === this.indexff) {
      this.indexff = null;
    }
    else {
      this.indexff = i;
    }
  }
  contactFilled() {
    this.healthConditionalObj.showContactassuredformbtn = true;
  }

  HealthOtherField(event, i) {
    if (this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_diabeties.value === 'YES') {
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_DiabDate.setValidators(Validators.required)
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_DiabDate.updateValueAndValidity()
    }
    else {
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_DiabDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_DiabDate.updateValueAndValidity()
    }
  }

  htf = 0
  hyperTensionField(event, i) {
    this.htf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.bpExistShow = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_bpDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.bpExistShow = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_bpDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_bpDate.updateValueAndValidity()
    }

  }
  ldf = 0
  liverDiseaseField(event, i) {
    this.ldf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.ldExistShow = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_ldDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.ldExistShow = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_ldDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_ldDate.updateValueAndValidity()
    }
  }
  cdf = 0
  cancerDiseaseField(event, i) {
    this.cdf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.cancerExistShow = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_CancerDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.cancerExistShow = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_CancerDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_CancerDate.updateValueAndValidity()
    }
  }
  cdef = 0
  cardiacDiseaseField(event, i) {
    this.cdef = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.cardiacExistShow = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_Cardiac.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.cardiacExistShow = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_Cardiac.clearValidators()
      // this.careProposalForm.get('cpf_Cardiac').clearValidators()
    }
  }
  jdf = 0
  jointDiseaseField(event, i) {
    this.jdf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.jointExistShow = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_jpDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.jointExistShow = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_jpDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_jpDate.updateValueAndValidity()

    }
  }
  kdf = 0
  kidneyDiseaseField(event, i) {
    this.kdf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showKidneyDate = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_kDiseaseDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showKidneyDate = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_kDiseaseDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_kDiseaseDate.updateValueAndValidity()
    }
  }
  pdf = 0
  paralysisDiseaseField(event, i) {
    this.pdf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showParalysis = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_paralysisDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showParalysis = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_paralysisDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_paralysisDate.updateValueAndValidity()
    }
  }
  //cf = 0;// commented for congenital que issue
  // congentialField(event, i) {
  //   this.cf = i
  //   if (event.detail.value === 'YES') {
  //     this.healthQuestionObj.showCongentail = true;
  //     this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_cdisorderDate.setValidators(Validators.required)
  //   }
  //   else if (event.detail.value === 'NO') {
  //     this.healthQuestionObj.showCongentail = false;
  //     this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_cdisorderDate.clearValidators()
  //     this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_cdisorderDate.updateValueAndValidity()

  //   }
  // }
  hf = 0;
  hivField(event, i) {
    this.hf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showHiv = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_hivDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showHiv = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_hivDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_hivDate.updateValueAndValidity()

    }
  }
  ef = 0
  endocrineField(event, i) {
    this.ef = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showEndo = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_EndCrineExistingDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showEndo = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_EndCrineExistingDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_EndCrineExistingDate.updateValueAndValidity()
    }
  }
  pef = 0
  pedEndoField(event, i) {
    this.pef = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showPedEndo = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_piExistingDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showPedEndo = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_piExistingDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_piExistingDate.updateValueAndValidity()
    }
  }
  pf = 0
  prolongedField(event, i) {
    this.pf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showProlonged = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_prolongedExisting.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showProlonged = false;
      // this.careProposalForm.get('cpf_prolongedExisting').clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_prolongedExisting.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_prolongedExisting.updateValueAndValidity()
    }
  }
  sf = 0
  smokeField(event, i) {
    console.log(event.detail.value)
    this.sf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showSmoke = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_smokeDesc.setValidators(Validators.required)
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_smokeExisting.setValidators(Validators.required)

      // this.careProposalForm.get('cpf_smokeExisting').setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showSmoke = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_smokeDesc.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_smokeDesc.updateValueAndValidity()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_smokeExisting.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_smokeExisting.updateValueAndValidity()
    }
  }
  oaf = 0
  otherAilmentField(event, i) {
    this.oaf = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showAilment = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_OtherAilmExistingDate.setValidators(Validators.required)
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_ailmentDesc.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showAilment = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_OtherAilmExistingDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_OtherAilmExistingDate.updateValueAndValidity()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_ailmentDesc.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_ailmentDesc.updateValueAndValidity()
    }
  }
  srd = 0
  showRespDetail(event, i) {
    this.srd = i
    if (event.detail.value === 'YES') {
      this.healthQuestionObj.showRespiratory = true;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_respExistingDate.setValidators(Validators.required)
    }
    else if (event.detail.value === 'NO') {
      this.healthQuestionObj.showRespiratory = false;
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_respExistingDate.clearValidators()
      this.careProposalForm.controls.proposalInfo['controls'][i].controls.cpf_respExistingDate.updateValueAndValidity()
    }
  }

  proposerClick() {
    console.log(this.propInfor)
    this.inCompleteApplicationData = {
      careProposerDetails: this.carePropDetailForm.value,
      careInsurerDetails: this.careProposalForm.value
    }
    // let findAge99 = this.respObj.find(item => item.age === '99')
    // let findAge98 = this.respObj.find(item => item.age === '98')
    // console.log(findAge98,this.respObj)
    // if (findAge99 && findAge98 || findAge99) {
    //   //console.log(findAge99)
    //   let findWhichArray99 = this.inCompleteApplicationData.careInsurerDetails.proposalInfo.find(item=>item.cpf_relName === findAge99.memberType)
    //     //console.log(element.cpf_Dob)
    //     let timeDiff = Math.abs(Date.now() - new Date(findWhichArray99.cpf_Dob).getTime());
    //     let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    //     console.log(age)
    //     if (age != 99) {
    //       this.healthConditionalObj.showAddress = false;
    //       this.toast.showToast("Age you are given is 98.Please enter right date of birth")
    //     }
    //     else if(age === 99) {
    //       this.healthConditionalObj.showAddress = true;
    //       this.healthConditionalObj.showMemDetails = false;
    //       this.healthConditionalObj.showPrpDetails = false;
    //       this.healthConditionalObj.showNominee = false;
    //       this.btnObj.memberFilled = "section-btn"
    //       this.btnObj.contactDetailsFilled = "section-btn active-section-btn";
    //       this.btnObj.proposerFilled = "section-btn"
    //       this.btnObj.nomineeDetailFilled = "section-btn"
    //       this.saveApplication();
    //     }

    // }
    // else if (findAge98) {
    //   let findWhichArray98 = this.inCompleteApplicationData.careInsurerDetails.proposalInfo.find(item=>item.cpf_relName === findAge98.memberType )
    //     console.log(findWhichArray98)
    //     let timeDiff = Math.abs(Date.now() - new Date(findWhichArray98.cpf_Dob).getTime());
    //     let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    //     console.log(age)
    //     if (age != 98) {
    //       this.healthConditionalObj.showAddress = false;
    //       this.toast.showToast("Age you are given is 98.Please enter right date of birth")
    //     }
    //     else if(age === 98) {
    //       this.healthConditionalObj.showAddress = true;
    //       this.healthConditionalObj.showMemDetails = false;
    //       this.healthConditionalObj.showPrpDetails = false;
    //       this.healthConditionalObj.showNominee = false;
    //       this.btnObj.memberFilled = "section-btn"
    //       this.btnObj.contactDetailsFilled = "section-btn active-section-btn";
    //       this.btnObj.proposerFilled = "section-btn"
    //       this.btnObj.nomineeDetailFilled = "section-btn"
    //       this.saveApplication();
    //     }

    // }
    // else {
    //   this.saveApplication();
    // }
    this.healthConditionalObj.showAddress = true;
    this.healthConditionalObj.showMemDetails = false;
    this.healthConditionalObj.showPrpDetails = false;
    this.healthConditionalObj.showNominee = false;
    this.btnObj.memberFilled = "section-btn"
    this.btnObj.contactDetailsFilled = "section-btn active-section-btn";
    this.btnObj.proposerFilled = "section-btn"
    this.btnObj.nomineeDetailFilled = "section-btn"
    this.saveApplication();
    this.scrollToTop();
  }

  contactClick() {
    this.healthConditionalObj.showAddress = false;
    this.healthConditionalObj.showMemDetails = false;
    this.healthConditionalObj.showNominee = true;
    this.btnObj.nomineeDetailFilled = "section-btn active-section-btn";
    this.btnObj.memberFilled = "section-btn"
    this.btnObj.proposerFilled = "section-btn"
    this.btnObj.contactDetailsFilled = "section-btn"
    this.inCompleteApplicationData = {
      careProposerDetails: this.carePropDetailForm.value,
      careInsurerDetails: this.careProposalForm.value,
      careContactDetails: this.careContactForm.value
    }
    this.saveApplication();
    if (this.nomineeForm.get('cpf_nomineeRelation').valid && this.nomineeForm.get('cpf_nomineeName').valid) {
      this.healthConditionalObj.disableCheck = false;
    }
    else {
      this.healthConditionalObj.disableCheck = true;
    }
    this.scrollToTop();
  }

  nomineeRelation(e) {
    if (this.nomineeForm.get('cpf_nomineeRelation').valid && this.nomineeForm.get('cpf_nomineeName').valid) {
      this.healthConditionalObj.disableCheck = false;
    }
    else {
      this.healthConditionalObj.disableCheck = true;
    }
  }

  nomineeName(e) {
    if (this.nomineeForm.get('cpf_nomineeRelation').valid && this.nomineeForm.get('cpf_nomineeName').valid) {
      this.healthConditionalObj.disableCheck = false
    }
    else {
      this.healthConditionalObj.disableCheck = true;
    }
  }

  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }

  getPincodeDetails(event) {
    let data = event.target.value
    this.loader.showLoader();
    this.apiService.getPincode(data).subscribe(res => {
      this.loader.hideLoader();
      this.pinCode = res.data;
      if (res.data.length > 0 && this.careContactForm.get('cpf_CorPincode').valid) {
        this.careContactForm.get('cpf_CorState').setValue(this.pinCode[0].stateCode)
        this.careContactForm.get('cpf_corCity').setValue(this.pinCode[0].cityCode)
        this.careContactForm.get('cpf_CorCount').setValue('India');
        this.careContactForm.get('cpf_CorPincode').setErrors(null);
      }
      else {
        this.careContactForm.get('cpf_CorPincode').setErrors({ "incorrect": true });
        this.careContactForm.get('cpf_State').setValue(null)
        this.careContactForm.get('cpf_corCity').setValue(null)
        this.careContactForm.get('cpf_CorCount').setValue('India');
      }
    }, err => {
      this.loader.hideLoader();
    })

  }

  getPermPincodeDetails() {
    let perPincode = this.careContactForm.get('cpf_Pincode').value;
    if (this.careContactForm.get('cpf_Pincode').value.length == 6) {
      this.loader.showLoader();
      this.apiService.getPincode(perPincode).subscribe(res => {
        this.loader.hideLoader();
        let pinCode = res.data;
        if (res.data.length > 0) {
          this.careContactForm.get('cpf_City').setValue(pinCode[0].cityCode)
          this.careContactForm.get('cpf_State').setValue(pinCode[0].stateCode)
          this.careContactForm.get('cpf_Country').setValue('India')
        }
        else {
          this.careContactForm.get('cpf_City').setValue(null)
          this.careContactForm.get('cpf_State').setValue(null)
          this.careContactForm.get('cpf_Country').setValue('India')
        }
      })
    }
  }

  saveNomineeDetails() {
    this.inCompleteApplicationData = {
      careProposerDetails: this.carePropDetailForm.value,
      careInsurerDetails: this.careProposalForm.value,
      careContactDetails: this.careContactForm.value,
      careNomineeDetails: this.nomineeForm.value,
    }
    this.saveApplication();
  }

  async submitProposal() {
    if (this.productName != 'Enhance 1') {
      this.submitFormData = {
        quoteId: this.quoteId,
        orderId: this.orderId,
        intPolicyDataIO: {
          policy: {
            partyDOList: this.partyList,
            policyAdditionalFieldsDOList: [
              {
                fieldAgree: "YES",
                fieldTc: this.agreeTcValue,
                fieldAlerts: this.agreeAlertValue,
                field1: "NEWFAVEO",
                field10: this.nomineeForm.get('cpf_nomineeName').value,
                field12: this.nomineeForm.get('cpf_nomineeRelation').value,
              }
            ],
            isPremiumCalculation: "YES",
            businessTypeCd: "NEWBUSINESS",
            // baseAgentId: "20008325",
            baseAgentId: "20210682",
            baseProductId: "10001101",
            sumInsured: this.sumCode,
            term: this.termValue,
            coverType: this.coverType,
            addOns: this.getAddOnsString,
            sumInsuredValue: Number(this.sumInsured),
            quotationPremium: this.premium,
            abacusId: String(this.abacusId),
            eldestMemberAge: this.eldestAge
          }
        }

      }
    }
    else if (this.productName === 'Enhance 1') {
      this.submitFormData = {
        quoteId: this.quoteId,
        orderId: this.orderId,
        intPolicyDataIO: {
          policy: {
            partyDOList: this.partyList,
            policyAdditionalFieldsDOList: [
              {
                fieldAgree: "YES",
                fieldTc: this.agreeTcValue,
                fieldAlerts: this.agreeAlertValue,
                field1: "Partner_MywealthJunction",
                field10: this.nomineeForm.get('cpf_nomineeName').value,
                field12: this.nomineeForm.get('cpf_nomineeRelation').value
              }
            ],
            addOns: this.addOnOption,
            isPremiumCalculation: "YES",
            businessTypeCd: this.productName,
            // baseAgentId: "20008325",
            baseAgentId: "20210682",
            baseProductId: "11001001",
            sumInsured: this.sumInsured,
            term: this.termData,
            coverType: this.coverType
          }
        }
      }
    }

    let insurerDataArray = []
    let guid;
    this.careProposalForm.controls.proposalInfo.value.forEach(element => {
      if (element.cpf_Relation === "SELF" && this.proposerDetailObj["relationCd"] === "SELF") {
        guid = this.proposerDetailObj["guid"];
      } else if (element.cpf_Relation === "SPSE" && this.proposerDetailObj["relationCd"] === "SPSE") {
        guid = this.proposerDetailObj["guid"];
      } else {
        guid = Math.floor(new Date().valueOf() * Math.random());
      }

      this.qustMemObj = [
        {
          questionSetCd: "PEDdiabetesDetails",
          questionCd: "205",
          response: element.cpf_diabeties,
        },

        {
          questionSetCd: "PEDhyperTensionDetails",
          questionCd: "207",
          response: element.cpf_bp,
        },

        {
          questionSetCd: "PEDliverDetails",
          questionCd: "232",
          response: element.cpf_ld
        },

        {
          questionSetCd: "PEDcancerDetails",
          questionCd: "114",
          response: element.cpf_Cancer
        },

        {
          questionSetCd: "PEDcardiacDetails",
          questionCd: "143",
          response: element.cpf_Cardiac
        },

        {
          questionSetCd: "PEDjointpainDetails",
          questionCd: "105",
          response: element.cpf_jPoint
        },

        {
          questionSetCd: "PEDkidneyDetails",
          questionCd: "129",
          response: element.cpf_kDisease
        },

        {
          questionSetCd: "PEDparalysisDetails",
          questionCd: "164",
          response: element.cpf_paralysis
        },

        // { // commented for congenital que issue
        //   questionSetCd: "PEDcongentialDetails",
        //   questionCd: "122",
        //   response: element.cpf_cdisorder
        // },

        {
          questionSetCd: "PEDHivaidsDetails",
          questionCd: "147",
          response: element.cpf_hiv
        },

        {
          questionSetCd: "yesNoExist",
          questionCd: "pedYesNo",
          response: element.cpf_preExitinsurer
        },
        {
          questionSetCd: "HEDHealthHospitalized",
          questionCd: "H001",
          response: element.cpf_hospFor
        },
        {
          questionSetCd: "HEDHealthClaim",
          questionCd: "H002",
          response: element.cpf_clcpInsurer
        },
        {
          questionSetCd: "HEDHealthDeclined",
          questionCd: "H003",
          response: element.cpf_hiDec
        },
        {
          questionSetCd: "HEDHealthCovered",
          questionCd: "H004",
          response: element.cpf_alreadyCovered
        },
        {
          questionSetCd: "PEDotherDetails",
          questionCd: "210",
          response: element.cpf_pedOtherDisease
        },

        {
          questionSetCd: "PEDRespiratoryDetails",
          questionCd: "250",
          response: element.cpf_pedRespDetail
        },

        {
          questionSetCd: "PEDEndoDetails",
          questionCd: "222",
          response: element.cpf_pedEndoDetails
        },

        {
          questionSetCd: "PEDillnessDetails",
          questionCd: "502",
          response: element.cpf_pedillnessDetails
        },

        {
          questionSetCd: "PEDSurgeryDetails",
          questionCd: "503",
          response: element.cpf_prolongedDetails
        },

        {
          questionSetCd: "PEDSmokeDetails",
          questionCd: "504",
          response: element.cpf_smokeDetails
        },

      ]
      let diabetes =
      {
        questionSetCd: "PEDdiabetesDetails",
        questionCd: "diabetesExistingSince",
        response: this._datePipe.transform(element.cpf_DiabDate, 'MM/yyyy')
      }
      if (element.cpf_diabeties != null && element.cpf_diabeties != 'NO') {
        this.qustMemObj.push(diabetes)
      }

      let bp =
      {
        questionSetCd: "PEDhyperTensionDetails",
        questionCd: "hyperTensionExistingSince",
        response: this._datePipe.transform(element.cpf_bpDate, 'MM/yyyy')
      }
      if (element.cpf_bp != null && element.cpf_bp != 'NO') {
        this.qustMemObj.push(bp)
      }

      let liver =
      {
        questionSetCd: "PEDliverDetails",
        questionCd: "liverExistingSince",
        response: this._datePipe.transform(element.cpf_ldDate, 'MM/yyyy')
      }
      if (element.cpf_ld != null && element.cpf_ld != 'NO') {
        this.qustMemObj.push(liver)
      }

      let cancer =
      {
        questionSetCd: "PEDcancerDetails",
        questionCd: "cancerExistingSince",
        response: this._datePipe.transform(element.cpf_CancerDate, 'MM/yyyy')
      }
      if (element.cpf_Cancer != null && element.cpf_Cancer != 'NO') {
        this.qustMemObj.push(cancer)
      }

      let cardiac =
      {
        questionSetCd: "PEDcardiacDetails",
        questionCd: "cardiacExistingSince",
        response: this._datePipe.transform(element.cpf_CardiacDate, 'MM/yyyy')
      }
      if (element.cpf_Cardiac != null && element.cpf_Cardiac != 'NO') {
        this.qustMemObj.push(cardiac)
      }

      let jointpain =
      {
        questionSetCd: "PEDjointpainDetails",
        questionCd: "jointpainExistingSince",
        response: this._datePipe.transform(element.cpf_jpDate, 'MM/yyyy')
      }
      if (element.cpf_jPoint != null && element.cpf_jPoint != 'NO') {
        this.qustMemObj.push(jointpain)
      }

      let kidney =
      {
        questionSetCd: "PEDkidneyDetails",
        questionCd: "kidneyExistingSince",
        response: this._datePipe.transform(element.cpf_kDiseaseDate, 'MM/yyyy')
      }
      if (element.cpf_kDisease != null && element.cpf_kDisease != 'NO') {
        this.qustMemObj.push(kidney)
      }

      let paralysis =
      {
        questionSetCd: "PEDparalysisDetails",
        questionCd: "paralysisExistingSince",
        response: this._datePipe.transform(element.cpf_paralysisDate, 'MM/yyyy')
      }
      if (element.cpf_paralysis != null && element.cpf_paralysis != 'NO') {
        this.qustMemObj.push(paralysis)
      }

      // let cdisorder = // commented for congenital que issue
      // {
      //   questionSetCd: "PEDcongentialDetails",
      //   questionCd: "congentialExistingSince",
      //   response: this._datePipe.transform(element.cpf_cdisorderDate, 'MM/yyyy')
      // }
      // if (element.cpf_cdisorder != null && element.cpf_cdisorder != 'NO') {
      //   this.qustMemObj.push(cdisorder)
      // }

      let hiv =
      {
        questionSetCd: "PEDHivaidsDetails",
        questionCd: "hivaidsExistingSince",
        response: this._datePipe.transform(element.cpf_hivDate, 'MM/yyyy')
      }
      if (element.cpf_hiv != null && element.cpf_hiv != 'NO') {
        this.qustMemObj.push(hiv)
      }

      let otherAilment =
      {
        questionSetCd: "PEDotherDetails",
        questionCd: "otheExistingSince",
        response: this.datePipe.transform(element.cpf_OtherAilmExistingDate, 'MM/yyyy')
      }
      let otherAilmentDesc =
      {
        questionSetCd: "PEDotherDetails",
        questionCd: "otherDiseasesDescription",
        response: element.cpf_ailmentDesc
      }

      if (element.cpf_pedOtherDisease != null && element.cpf_pedOtherDisease != 'NO') {
        this.qustMemObj.push(otherAilment, otherAilmentDesc)
      }

      let respdisorder =
      {
        questionSetCd: "PEDRespiratoryDetails",
        questionCd: "respiratoryExistingSince",
        response: this._datePipe.transform(element.cpf_respExistingDate, 'MM/yyyy')
      }
      if (element.cpf_pedRespDetail != null && element.cpf_pedRespDetail != 'NO') {
        this.qustMemObj.push(respdisorder)
      }

      let endocrine =
      {
        questionSetCd: "PEDEndoDetails",
        questionCd: "EndocriExistingSince",
        response: this._datePipe.transform(element.cpf_EndCrineExistingDate, 'MM/yyyy')
      }
      if (element.cpf_pedEndoDetails != null && element.cpf_pedEndoDetails != 'NO') {
        this.qustMemObj.push(endocrine)
      }

      let injured =
      {
        questionSetCd: "PEDillnessDetails",
        questionCd: "illnessExistingSince",
        response: this._datePipe.transform(element.cpf_piExistingDate, 'MM/yyyy')
      }
      if (element.cpf_pedillnessDetails != null && element.cpf_pedillnessDetails != 'NO') {
        this.qustMemObj.push(injured)
      }

      let surgery =
      {
        questionSetCd: "PEDSurgeryDetails",
        questionCd: "SurgeryExistingSince",
        response: this._datePipe.transform(element.cpf_prolongedExisting, 'MM/yyyy')
      }
      if (element.cpf_prolongedDetails != null && element.cpf_prolongedDetails != 'NO') {
        this.qustMemObj.push(surgery)
      }

      let smoke =
      {
        questionSetCd: "PEDSmokeDetails",
        questionCd: "SmokeExistingSince",
        response: this._datePipe.transform(element.cpf_smokeExisting, 'MM/yyyy')
      }
      let smokeDesc =
      {
        questionSetCd: "PEDSmokeDetails",
        questionCd: "OtherSmokeDetails",
        response: element.cpf_smokeDesc
      }

      if (element.cpf_smokeDetails != null && element.cpf_smokeDetails != 'NO') {
        this.qustMemObj.push(smoke, smokeDesc)
      }

      this.partyList = {
        guid: String(guid),
        firstName: element.cpf_fName,
        lastName: element.cpf_lName,
        roleCd: "PRIMARY",
        height: Number(element.cpf_height),
        weight: Number(element.cpf_weight),
        birthDt: element.cpf_Dob,//this.datePipe.transform(element.cpf_Dob, "dd/MM/yyyy"),
        genderCd: element.cpf_gender,
        titleCd: element.cpf_title,
        relationCd: element.cpf_Relation,
        partyQuestionDOList: this.qustMemObj,
        partyIdentityDOList: [
          {
            identityTypeCd: element.cpf_Idtype,
            identityNum: (element.cpf_idNumber).toUpperCase() //ToDO PAn NUMber
          }
        ],
        partyAddressDOList: [
          {
            addressTypeCd: "PERMANENT",
            addressLine1Lang1: this.careContactForm.get('cpf_Houseno').value,
            addressLine2Lang1: this.careContactForm.get('cpf_Street').value,
            stateCd: this.careContactForm.get('cpf_State').value,
            cityCd: this.careContactForm.get('cpf_City').value,
            pinCode: this.careContactForm.get('cpf_Pincode').value,
            areaCd: this.careContactForm.get('cpf_City').value,
            countryCd: this.careContactForm.get('cpf_Country').value
          },
          {
            addressTypeCd: "COMMUNICATION",
            addressLine1Lang1: this.careContactForm.get('cpf_CorHous').value,
            addressLine2Lang1: this.careContactForm.get('cpf_CorStreet').value,
            stateCd: this.careContactForm.get('cpf_CorState').value,
            cityCd: this.careContactForm.get('cpf_corCity').value,
            pinCode: this.careContactForm.get('cpf_CorPincode').value,
            areaCd: this.careContactForm.get('cpf_corCity').value,
            countryCd: this.careContactForm.get('cpf_CorCount').value
          }
        ],
        partyContactDOList: [
          {
            contactTypeCd: "MOBILE",
            contactNum: this.careContactForm.get('cpf_contactNo').value,
            stdCode: "+91"
          }
        ],
        partyEmailDOList: [
          {
            emailTypeCd: "PERSONAL",
            emailAddress: this.careContactForm.get('cpf_Email').value
          }
        ]
      }
      insurerDataArray.push(this.partyList)
    });
    this.proposerDetailObj['partyAddressDOList'] = this.partyList.partyAddressDOList;
    this.proposerDetailObj['partyContactDOList'] = this.partyList.partyContactDOList;
    this.proposerDetailObj['partyEmailDOList'] = this.partyList.partyEmailDOList;
    insurerDataArray.push(this.proposerDetailObj);
    this.submitFormData.intPolicyDataIO.policy.partyDOList = insurerDataArray;

    const modal = await this.modalCtrl.create({
      component: ProposalComponent,
      componentProps: {
        dataSelected: this.submitFormData,
      },
      cssClass: "selected-info-modal",
      showBackdrop: false,
      backdropDismiss: false,
      swipeToClose: true
    });
    modal.onDidDismiss().then((isOkay) => {
      if (isOkay.data.goForward) {
        this.loader.showLoader("It may take a while. Your patience is truly appreciated")
        let questionList = [];
        isOkay.data.dataSelected.intPolicyDataIO.policy.partyDOList.forEach(item => {
          if (item.roleCd === "PRIMARY" && item.relationCd === "SELF" && this.proposerDetailObj["relationCd"] === "SELF") {
            questionList = item.partyQuestionDOList;
          } else if (item.roleCd === "PRIMARY" && item.relationCd === "SPSE" && this.proposerDetailObj["relationCd"] === "SPSE") {
            questionList = item.partyQuestionDOList;
          }

          if (item.roleCd === "PROPOSER" && item.relationCd === "SELF" && this.proposerDetailObj["relationCd"] === "SELF") {
            item.partyQuestionDOList = questionList;
          }

          if (item.roleCd === "PROPOSER" && item.relationCd === "SPSE" && this.proposerDetailObj["relationCd"] === "SPSE") {
            item.partyQuestionDOList = questionList;
          }

          console.log("oooooodvdvdvdvdvdvd 5")
          if (item.roleCd === "PROPOSER") {
            console.log("oooooodvdvdvdvdvdvd 6")
            if (this.ckycNo) {
              item["ckyc"] = "YES";
              item["ckycNumber"] = this.ckycNo;
            } else if (this.eKycRefNo) {
              item["ekyc"] = "YES";
              item["ekycRefNo"] = this.eKycRefNo;
            } else {
              item["ovdkyc"] = "YES";
            }
          }
        })

        if (this.productName != 'Enhance 1') {
          console.log("oooooodvdvdvdvdvdvd 7", isOkay.data.dataSelected);
          this.apiService.postCareSubmitApplication(isOkay.data.dataSelected).subscribe(res => {
            this.loader.hideLoader();
            let submitformResp = JSON.parse(res.data.response)
            if (submitformResp.responseData.message === 'Success') {
              this.proposalNumber = submitformResp.intPolicyDataIO.policy.proposalNum;
              if (this.ckycNo || this.eKycRefNo) {
                this.healthConditionalObj.showSuccessMsg = true;
              } else {
                this.strg.setStoreData("careOvdKyc", "true");
                this.strg.setStoreData("careHealthBasicReqData", isOkay.data.dataSelected);
                this.strg.setStoreData("careHealthBasicResData", submitformResp);
                this.careAppSubRes = submitformResp;
                this.showCareOvdkycDocsUpload = true;
              }

            }
          }, err => {
            this.loader.hideLoader();
            let errmsg = JSON.parse(err.error.message)
            this.toast.showToast(errmsg[0].errDescription, 5000)
          })
        }
        else if (this.productName === 'Enhance 1') {
          this.apiService.postCareTopUp(isOkay.data.dataSelected).subscribe(res => {
            this.loader.hideLoader();
            let submitformResp = JSON.parse(res.data.response)
            if (submitformResp.responseData.message === 'Success') {
              this.proposalNumber = submitformResp.intPolicyDataIO.policy.proposalNum;
              this.healthConditionalObj.showSuccessMsg = true;
            }
          }, err => {
            this.loader.hideLoader();
            let errmsg = JSON.parse(err.error.message)
            this.toast.showToast(errmsg[0].errDescription, 5000)
          })
        }
      }
    });
    return await modal.present();
  }
  isCurrentAddrSame(event) {
    if (event.detail.checked === true) {
      this.healthConditionalObj.showPermAdd = false;
      this.careContactForm.get('cpf_CorHous').setValue(this.careContactForm.get('cpf_Houseno').value)
      this.careContactForm.get('cpf_CorStreet').setValue(this.careContactForm.get('cpf_Street').value)
      this.careContactForm.get('cpf_CorLand').setValue(this.careContactForm.get('cpf_Landmark').value)
      this.careContactForm.get('cpf_CorPincode').setValue(this.careContactForm.get('cpf_Pincode').value)
      this.careContactForm.get('cpf_corCity').setValue(this.careContactForm.get('cpf_City').value)
      this.careContactForm.get('cpf_CorState').setValue(this.careContactForm.get('cpf_State').value)
      this.careContactForm.get('cpf_CorCount').setValue(this.careContactForm.get('cpf_Country').value)
    }
    else if (event.detail.checked === false) {
      this.healthConditionalObj.showPermAdd = true;
    }
  }
  checkItsNotZero(e) {
    console.log("Check");
    if (e.target.value === '0') {
      this.toast.showToast('Please enter valid weight/height')
      if (this.carePropDetailForm.get('cpf_prpHeight').value === '0') {
        this.carePropDetailForm.get('cpf_prpHeight').setValue(null)
      }
      else if (this.carePropDetailForm.get('cpf_prpWeight').value === '0') {
        this.carePropDetailForm.get('cpf_prpWeight').setValue(null)
      }
      else if (this.carePropDetailForm.get('cpf_height').value === '0') {
        this.carePropDetailForm.get('cpf_Height').setValue(null)
      }
      else if (this.carePropDetailForm.get('cpf_weight').value === '0') {
        this.carePropDetailForm.get('cpf_Weight').setValue(null)
      }
    }
  }
  getQuoteResId() {
    let dataa = {
      productName: "CARE",
      latest: true
    }
    this.apiService.getQuotesByUserId(dataa).subscribe(res => {
      let quoteIdRes = res.data.pop()
      this.quoteId = quoteIdRes.id
      let careData = JSON.parse(quoteIdRes.responseParam)
      this.respObj = [];
      console.log(careData)
      this.quoteValue = careData;
      if (this.productName != 'Enhance 1') {
        this.strg.getStoreData("hcr_addOns").then(value => {
          this.getAddOns = value;
          let ff = '';
          this.getAddOnsString = ''
          this.getAddOns.forEach(element => {
            this.getAddOnsString += element + ','
          });
        })
        this.abacusId = careData.careQuoteResponse.responseParam.abacusData.abacusId;
        this.premium = careData.careQuoteResponse.responseParam.grandTotal.selectedValue;
        this.sumInsured = careData.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_2").selectedValue;
        this.sumCode = careData.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_2").selectedValueCode;
        this.eldestAge = careData.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_3").selectedValue;
        let termDetails = careData.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_4")
        this.termValue = Number(termDetails.selectedValue.substring(0, termDetails.selectedValue.length - 5).trim());
        this.coverType = careData.careQuoteResponse.responseParam.inputFields.find(item => item.fieldName == "field_9").selectedValue === 'Floater' ? 'FAMILYFLOATER' : 'INDIVIDUAL';
        this.respObj = careData.careQuoteRequest.reqParam.insurer;
        this.respObj.forEach(element => {
          if (element.name === 'Son' || element.name === "Father" || element.name === "Grand-Father" || element.name === "Father-in-Law" || element.name === "Brother" || element.name === "GrandSon" || element.name === "Uncle" || element.name === "Nephew") {
            this.personalInfoObj.salutation = 'MR';
            this.personalInfoObj.gender = "MALE"
            this.personalInfoObj.genderDisBtn = true;
          }
          else if (element.name === 'Daughter' || element.name === "Mother" || element.name === "Grand-Mother" || element.name === "Mother-in-Law" || element.name === "Sister" || element.name === "GrandDaughter" || element.name === "Niece") {
            this.personalInfoObj.salutation = 'MS';
            this.personalInfoObj.gender = "FEMALE";
            this.personalInfoObj.genderDisBtn = true
          }
          else {
            this.personalInfoObj.salutation = '';
            this.personalInfoObj.gender = "";
            this.personalInfoObj.genderDisBtn = false;
          }
          let customValidate;
          if (element.name === 'Son' || element.name === 'Daughter' || element.name === "GrandSon" || element.name === "GrandDaughter" || element.name === "Nephew" || element.name === "Niece") {
            customValidate = dobValidate2;
          } else {
            customValidate = dobValidate;
          }
          this.propInfor.push(this.fb.group({
            // cpf_click: [this.clickFunction],
            cpf_relName: [element.name],
            cpf_title: [this.personalInfoObj.salutation, [Validators.required]],
            cpf_fName: ['', [Validators.required]],
            cpf_lName: ['', [Validators.required]],
            cpf_Dob: ['', [Validators.required, customValidate]],
            cpf_gender: [this.personalInfoObj.gender, [Validators.required]],
            cpf_Relation: [element.value, [Validators.required]],
            cpf_Idtype: [''],
            cpf_idNumber: ['', Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")],
            cpf_diabeties: ['', Validators.required],
            cpf_DiabDate: [''],
            cpf_bp: ['', Validators.required],
            cpf_bpDate: [''],
            cpf_ld: ['', Validators.required],
            cpf_ldDate: [''],
            cpf_Cancer: ['', Validators.required],
            cpf_CancerDate: [''],
            cpf_Cardiac: ['', Validators.required],
            cpf_CardiacDate: [''],
            cpf_jPoint: ['', Validators.required],
            cpf_jpDate: [''],
            cpf_kDisease: ['', Validators.required],
            cpf_kDiseaseDate: [''],
            cpf_paralysis: ['', Validators.required],
            cpf_paralysisDate: [''],
            // cpf_cdisorder: ['', Validators.required],// commented for congenital que issue
            // cpf_cdisorderDate: [''],
            cpf_hiv: ['', Validators.required],
            cpf_hivDate: [''],
            cpf_preExitinsurer: ['', Validators.required],
            cpf_clcpInsurer: ['', Validators.required],
            cpf_pedillnessDetails: ['', Validators.required],
            cpf_hiDec: ['', Validators.required],
            cpf_alreadyCovered: ['', Validators.required],
            cpf_hospFor: ['', Validators.required],
            cpf_pedOtherDisease: ['', Validators.required],
            cpf_OtherAilmExistingDate: [''],
            cpf_ailmentDesc: [''],
            cpf_pedRespDetail: ['', Validators.required],
            cpf_respExistingDate: [''],
            cpf_pedEndoDetails: ['', Validators.required],
            cpf_EndCrineExistingDate: [''],
            cpf_piExistingDate: [''],
            cpf_PrillExisting: [''],
            cpf_smokeDetails: ['', Validators.required],
            cpf_smokeExisting: [''],
            cpf_smokeDesc: [''],
            cpf_prolongedDetails: ['', Validators.required],
            cpf_prolongedExisting: [''],
          }))
          if (this.respObj.length === 1 && element.value === 'SELF') {
            this.carePropDetailForm.get('cpf_prpRelation').setValue('SELF')
          }
          else {
            this.carePropDetailForm.get('cpf_prpRelation').setValue(null)
          }
        });
        if (this.premium.replace(/,/g, '') >= 50000) {
          this.personalInfoObj.pandetail = true;
        }
        else if (this.premium.replace(/,/g, '') < 50000) {
          this.personalInfoObj.pandetail = false;
        }
      }
      else if (this.productName === 'Enhance 1') {
        console.log('Enhance 1 aksjdhkajsdhsa dkjahsd ', careData);
        console.log("Enhance 1 product is available 2")
        this.carePropDetailForm.get('cpf_prpHeight').setValidators(Validators.required);
        this.carePropDetailForm.get('cpf_prpHeight').updateValueAndValidity();
        this.carePropDetailForm.get('cpf_prpWeight').setValidators(Validators.required);
        this.carePropDetailForm.get('cpf_prpWeight').updateValueAndValidity();
        this.abacusId = careData.abacusData.abacusId;
        this.premium = careData.outputFields.find(item => item.fieldName === "field_8").premium;
        this.eldestAge = careData.inputFields.find(item => item.fieldName == "field_3").selectedValue;
        let termDetails = careData.inputFields.find(item => item.fieldName == "field_4");
        this.termValue = Number(termDetails.selectedValue.substring(0, termDetails.selectedValue.length - 5).trim());
        this.coverType = careData.inputFields.find(item => item.fieldName == "field_9").selectedValue === 'Individual' ? 'INDIVIDUAL' : 'FAMILYFLOATER';
        this.sumInsured = careData.inputFields.find(item => item.fieldName == "field_2").selectedValueCode;

        if (this.premium.replace(/,/g, '') >= 50000) {
          this.personalInfoObj.pandetail = true;
        }
        else if (this.premium.replace(/,/g, '') < 50000) {
          this.personalInfoObj.pandetail = false;
        }
        else {
          console.log("akjsdjakhsdlkajhsdkjahds", careData)
          this.abacusId = this.careTopUpDetails.abacusData.abacusId;
        }
        if (careData.inputFields[7].selectedValue === '1 Year' || careData.inputFields[7].selectedValue === '1') {
          this.termData = 1
        }
        else if (careData.inputFields[7].selectedValue === '2 Year' || careData.inputFields[7].selectedValue === '2') {
          this.termData = 2
        }
        else if (careData.inputFields[7].selectedValue === '3 Year' || careData.inputFields[7].selectedValue === '3') {
          this.termData = 3
        }
        let careReqData = JSON.parse(quoteIdRes.insuranceQuoteRequest.reqParam)
        this.respObj = careReqData.reqParam.membersArray

        this.respObj.forEach(element => {
          if (element.memberType === 'Son' || element.memberType === "Father" || element.memberType === "Grand-Father" || element.memberType === "Father-in-Law" || element.memberType === "Brother" || element.memberType === "GrandSon" || element.memberType === "Uncle" || element.memberType === "Nephew") {
            this.personalInfoObj.salutation = 'MR';
            this.personalInfoObj.gender = "MALE"
            this.personalInfoObj.genderDisBtn = true;
          }
          else if (element.memberType === 'Daughter' || element.memberType === "Mother" || element.memberType === "Grand-Mother" || element.memberType === "Mother-in-Law" || element.memberType === "Sister" || element.memberType === "GrandDaughter" || element.memberType === "Niece") {
            this.personalInfoObj.salutation = 'MS';
            this.personalInfoObj.gender = "FEMALE";
            this.personalInfoObj.genderDisBtn = true
          }
          else {
            this.personalInfoObj.salutation = '';
            this.personalInfoObj.gender = "";
            this.personalInfoObj.genderDisBtn = false;
          }
          let customValidate;
          if (element.memberType === 'Son' || element.memberType === 'Daughter' || element.memberType === "GrandSon" || element.memberType === "GrandDaughter" || element.memberType === "Nephew" || element.memberType === "Niece") {
            customValidate = dobValidate2;
          } else {
            customValidate = dobValidate;
          }
          if (element.memberType === 'Self') {
            element.value = 'SELF'
          }
          else if (element.memberType === 'Spouse') {
            element.value = 'SPSE'
          }
          else if (element.memberType === 'Son') {
            element.value = 'SONM'
          }
          else if (element.memberType === 'Daughter') {
            element.value = 'UDTR'
          }
          else if (element.memberType === 'Father') {
            element.value = 'FATH'
          }
          else if (element.memberType === 'Mother') {
            element.value = 'MOTH'
          }
          else if (element.memberType === 'Brother') {
            element.value = 'BOTH'
          }
          else if (element.memberType === 'Sister') {
            element.value = 'SIST'
          }
          else if (element.memberType === 'GrandSon') {
            element.value = 'GSON'
          }
          else if (element.memberType === 'GrandDaughter') {
            element.value = 'GDAU'
          }
          else if (element.memberType === 'Uncle') {
            element.value = 'MUNC'
          }
          else if (element.memberType === 'Newphew') {
            element.value = 'NEPH'
          }
          else if (element.memberType === 'Niece') {
            element.value = 'NIEC'
          }
          else if (element.memberType === 'Grand-Mother') {
            element.value = 'GMOT'
          }
          else if (element.memberType === 'Grand-Father') {
            element.value = 'GFAT'
          }
          else if (element.memberType === 'Mother-in-Law') {
            element.value = 'MLAW'
          }
          else if (element.memberType === 'Father-in-Law') {
            element.value = 'FLAW'
          }

          this.propInfor.push(this.fb.group({
            // cpf_click: [this.clickFunction],
            cpf_relName: [element.memberType],
            cpf_title: [this.personalInfoObj.salutation, [Validators.required]],
            cpf_fName: ['', [Validators.required]],
            cpf_lName: ['', [Validators.required]],
            cpf_Dob: ['', [Validators.required, customValidate]],
            cpf_gender: [this.personalInfoObj.gender, [Validators.required]],
            cpf_Relation: [element.value, [Validators.required]],
            cpf_Idtype: [''],
            cpf_idNumber: ['', Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")],
            cpf_height: [''],
            cpf_weight: [''],
            cpf_diabeties: ['', Validators.required],
            cpf_DiabDate: [''],
            cpf_bp: ['', Validators.required],
            cpf_bpDate: [''],
            cpf_ld: ['', Validators.required],
            cpf_ldDate: [''],
            cpf_Cancer: ['', Validators.required],
            cpf_CancerDate: [''],
            cpf_Cardiac: ['', Validators.required],
            cpf_CardiacDate: [''],
            cpf_jPoint: ['', Validators.required],
            cpf_jpDate: [''],
            cpf_kDisease: ['', Validators.required],
            cpf_kDiseaseDate: [''],
            cpf_paralysis: ['', Validators.required],
            cpf_paralysisDate: [''],
            // cpf_cdisorder: ['', Validators.required],// commented for congenital que issue
            // cpf_cdisorderDate: [''],
            cpf_hiv: ['', Validators.required],
            cpf_hivDate: [''],
            cpf_preExitinsurer: ['', Validators.required],
            cpf_clcpInsurer: ['', Validators.required],
            cpf_pedillnessDetails: ['', Validators.required],
            cpf_hiDec: ['', Validators.required],
            cpf_alreadyCovered: ['', Validators.required],
            cpf_hospFor: ['', Validators.required],
            cpf_pedOtherDisease: ['', Validators.required],
            cpf_OtherAilmExistingDate: [''],
            cpf_ailmentDesc: [''],
            cpf_pedRespDetail: ['', Validators.required],
            cpf_respExistingDate: [''],
            cpf_pedEndoDetails: ['', Validators.required],
            cpf_EndCrineExistingDate: [''],
            cpf_piExistingDate: [''],
            cpf_PrillExisting: [''],
            cpf_smokeDetails: ['', Validators.required],
            cpf_smokeExisting: [''],
            cpf_smokeDesc: [''],
            cpf_prolongedDetails: ['', Validators.required],
            cpf_prolongedExisting: [''],
          }))
          if (this.respObj.length === 1 && element.value === 'SELF') {
            this.carePropDetailForm.get('cpf_prpRelation').setValue('SELF')
          }
          else {
            this.carePropDetailForm.get('cpf_prpRelation').setValue('SELF')
          }
        });


      }
      let getspse = this.respObj.find(item => item.value === "SPSE");
      if (getspse != undefined) {
        this.showSposeProp = true;
      } else {
        this.showSposeProp = false;
      }
      for (let i = 0; i < this.careProposalForm.controls.proposalInfo['controls'].length; i++) {
        if (this.premium.replace(/,/g, '') >= 50000) {
          this.personalInfoObj.pandetail = true;
          this.carePropDetailForm.get('cpf_prpIdtype').setValidators(Validators.required)
          this.carePropDetailForm.get('cpf_prpIdNumber').setValidators([Validators.required, Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")])
        }
        else {
          this.personalInfoObj.pandetail = false;
          this.carePropDetailForm.get('cpf_prpIdtype').clearValidators()
          this.carePropDetailForm.get('cpf_prpIdNumber').clearValidators()
          this.carePropDetailForm.get('cpf_prpIdtype').updateValueAndValidity()
          this.carePropDetailForm.get('cpf_prpIdNumber').updateValueAndValidity()
        }
      }

      if (careData.data) {
        this.careTopUpDetails = careData.data
      }
      else {
        this.careTopUpDetails = careData
      }
      let data = {
        quoteResponseId: quoteIdRes.id
      }
      this.apiService.getApplicationOrderId(data).subscribe(res => {
        this.orderId = res.data.id
      })
      this.autoFillCKYCDetails();
    })
  }
  inCompleteApplicationData: any
  saveApplication() {

    let saveData = {
      orderId: this.orderId,
      applicationData: this.inCompleteApplicationData
    }
    this.apiService.saveIncompleteICICIAppData(saveData).subscribe(res => {
    }, err => {
    });
  }

  genderAutoFill(event, i) {
    this.propInfor.controls.forEach(f => {
      if (f.get('cpf_title').value === "MR") {
        f.get('cpf_gender').setValue("MALE");
        // f.get('cpf_gender').disable({ onlySelf: true });
        f.get('cpf_gender').updateValueAndValidity();
      }
      else if (f.get('cpf_title').value === "MS") {
        f.get('cpf_gender').setValue("FEMALE");
        f.get('cpf_gender').updateValueAndValidity();
      }
    })
  }
  agree(event) {
    this.agreeValue = event.detail.checked === true ? "YES" : "NO";
  }
  agreeTc(event) {
    this.agreeTcValue = event.detail.checked === true ? "YES" : "NO";
  }
  agreeAlert(event) {
    this.agreeAlertValue = event.detail.checked === true ? "YES" : "NO";
  }
  validateLettersOnly(event) {
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }
  backBtn() {
    this.healthConditionalObj.showSuccessMsg = false;
  }
  backToProp() {
    this.healthConditionalObj.showAddress = false;
    this.healthConditionalObj.showMemDetails = true;
    this.healthConditionalObj.showNominee = false;
    this.btnObj.proposerFilled = "section-btn";
    this.btnObj.memberFilled = "section-btn active-section-btn"
    this.btnObj.contactDetailsFilled = "section-btn";
    this.btnObj.nomineeDetailFilled = "section-btn";
    this.btnObj.contactSegment = "section-btn";
  }
  backToAddress() {
    this.healthConditionalObj.showAddress = true;
    this.healthConditionalObj.showNominee = false;
    this.healthConditionalObj.showMemDetails = false
    this.btnObj.proposerFilled = "section-btn";
    this.btnObj.memberFilled = "section-btn"
    this.btnObj.contactDetailsFilled = "section-btn active-section-btn";
    this.btnObj.nomineeDetailFilled = "section-btn";
    this.btnObj.contactSegment = "section-btn";
  }
  valueIfChange() {
    this.healthConditionalObj.isAddrSame = false;
  }
  test(event) {
    let diaDate = this._datePipe.transform(event.target.value, 'MM/yyyy')
  }
  propDetailClick() {
    this.inCompleteApplicationData = {
      careProposerDetails: this.carePropDetailForm.value,
    }
    this.saveApplication();
    this.strg.setStoreData("hlIncp", true);
    let guid = Math.floor(new Date().valueOf() * Math.random());
    this.proposerDetailObj = {
      guid: String(guid),
      firstName: this.carePropDetailForm.get('cpf_prpFName').value,
      lastName: this.carePropDetailForm.get('cpf_prpLName').value,
      roleCd: "PROPOSER",
      birthDt: this.carePropDetailForm.get('cpf_prpDob').value,//this.datePipe.transform(this.carePropDetailForm.get('cpf_prpDob').value, "dd/MM/yyyy"),
      genderCd: this.carePropDetailForm.get('cpf_prpGender').value,
      height: Number(this.carePropDetailForm.get('cpf_prpHeight').value),
      weight: Number(this.carePropDetailForm.get('cpf_prpWeight').value),
      titleCd: this.carePropDetailForm.get('cpf_prpSalutation').value,
      relationCd: this.carePropDetailForm.get('cpf_prpRelation').value,
      partyQuestionDOList: [],
      partyIdentityDOList: [
        {
          identityTypeCd: this.carePropDetailForm.get('cpf_prpIdtype').value,
          identityNum: (this.carePropDetailForm.get('cpf_prpIdNumber').value).toUpperCase(),//ToDO PAn NUMber
        }
      ],
      partyAddressDOList: [
        {
          addressTypeCd: "PERMANENT",
          addressLine1Lang1: this.careContactForm.get('cpf_Houseno').value,
          addressLine2Lang1: this.careContactForm.get('cpf_Street').value,
          stateCd: this.careContactForm.get('cpf_State').value,
          cityCd: this.careContactForm.get('cpf_City').value,
          pinCode: this.careContactForm.get('cpf_Pincode').value,
          areaCd: this.careContactForm.get('cpf_City').value,
          countryCd: this.careContactForm.get('cpf_Country').value
        },
        {
          addressTypeCd: "COMMUNICATION",
          addressLine1Lang1: this.careContactForm.get('cpf_CorHous').value,
          addressLine2Lang1: this.careContactForm.get('cpf_CorStreet').value,
          stateCd: this.careContactForm.get('cpf_CorState').value,
          cityCd: this.careContactForm.get('cpf_corCity').value,
          pinCode: this.careContactForm.get('cpf_CorPincode').value,
          areaCd: this.careContactForm.get('cpf_corCity').value,
          countryCd: this.careContactForm.get('cpf_CorCount').value
        }
      ],
      partyContactDOList: [
        {
          contactTypeCd: "MOBILE",
          contactNum: this.careContactForm.get('cpf_contactNo').value,
          stdCode: "+91"
        }
      ],
      partyEmailDOList: [
        {
          emailTypeCd: "PERSONAL",
          emailAddress: this.careContactForm.get('cpf_Email').value
        }
      ]
    }
    this.healthConditionalObj.showMemDetails = true;
    this.healthConditionalObj.showAddress = false;
    this.healthConditionalObj.showNominee = false;
    this.healthConditionalObj.showPrpDetails = false;
    this.btnObj.proposerFilled = "section-btn";
    this.btnObj.memberFilled = "section-btn active-section-btn"
    this.btnObj.contactDetailsFilled = "section-btn";
    this.btnObj.nomineeDetailFilled = "section-btn";
    this.btnObj.contactSegment = "section-btn";
    let findSelfRelation = this.careProposalForm.controls.proposalInfo['controls']
    if (this.carePropDetailForm.get('cpf_prpRelation').value === 'SELF' && findSelfRelation[0].value.cpf_Relation === 'SELF') {
      findSelfRelation[0].controls.cpf_title.setValue(this.carePropDetailForm.get('cpf_prpSalutation').value);
      findSelfRelation[0].controls.cpf_fName.setValue(this.carePropDetailForm.get('cpf_prpFName').value);
      findSelfRelation[0].controls.cpf_lName.setValue(this.carePropDetailForm.get('cpf_prpLName').value);
      findSelfRelation[0].controls.cpf_gender.setValue(this.carePropDetailForm.get('cpf_prpGender').value);
      findSelfRelation[0].controls.cpf_Dob.setValue(this.carePropDetailForm.get('cpf_prpDob').value);
      findSelfRelation[0].controls.cpf_Idtype.setValue(this.carePropDetailForm.get('cpf_prpIdtype').value);
      findSelfRelation[0].controls.cpf_idNumber.setValue(this.carePropDetailForm.get('cpf_prpIdNumber').value);
      findSelfRelation[0].controls.cpf_height.setValue(this.carePropDetailForm.get('cpf_prpHeight').value);
      findSelfRelation[0].controls.cpf_weight.setValue(this.carePropDetailForm.get('cpf_prpWeight').value);
    }
    let findSpouseRelation = this.careProposalForm.controls.proposalInfo['controls']
    if (this.carePropDetailForm.get('cpf_prpRelation').value === 'SPSE' && findSpouseRelation[1].value.cpf_Relation === 'SPSE' || findSpouseRelation[0].value.cpf_Relation === 'SPSE') {
      findSpouseRelation[1].controls.cpf_title.setValue(this.carePropDetailForm.get('cpf_prpSalutation').value);
      findSpouseRelation[1].controls.cpf_fName.setValue(this.carePropDetailForm.get('cpf_prpFName').value);
      findSpouseRelation[1].controls.cpf_lName.setValue(this.carePropDetailForm.get('cpf_prpLName').value);
      findSpouseRelation[1].controls.cpf_gender.setValue(this.carePropDetailForm.get('cpf_prpGender').value);
      findSpouseRelation[1].controls.cpf_Dob.setValue(this.carePropDetailForm.get('cpf_prpDob').value);
      findSpouseRelation[1].controls.cpf_Idtype.setValue(this.carePropDetailForm.get('cpf_prpIdtype').value);
      findSpouseRelation[1].controls.cpf_idNumber.setValue(this.carePropDetailForm.get('cpf_prpIdNumber').value);
      findSpouseRelation[1].controls.cpf_height.setValue(this.carePropDetailForm.get('cpf_prpHeight').value);
      findSpouseRelation[1].controls.cpf_weight.setValue(this.carePropDetailForm.get('cpf_prpWeight').value);
    }
    this.scrollToTop();
  }
  scrollToTop() {
    console.log("scrolllll to topppp erererer")
    window.scrollTo(0, 0);
  }
  proposalGenderAutoFill(event) {
    if (event.target.value === "MR") {
      this.carePropDetailForm.get('cpf_prpGender').setValue('MALE')
    }
    else if (event.target.value === "MS") {
      this.carePropDetailForm.get('cpf_prpGender').setValue('FEMALE')
    }
  }

  backToProposal() {
    this.healthConditionalObj.showPrpDetails = true;
    this.healthConditionalObj.showAddress = false;
    this.healthConditionalObj.showMemDetails = false;
    this.healthConditionalObj.showNominee = false;
    this.btnObj.proposerFilled = "section-btn active-section-btn";
    this.btnObj.memberFilled = "section-btn"
    this.btnObj.contactDetailsFilled = "section-btn";
    this.btnObj.nomineeDetailFilled = "section-btn";
    this.btnObj.contactSegment = "section-btn";
  }

  selectIdProof() {
    document.getElementById("idProof").click();
  }

  selectAddrProof() {
    document.getElementById("addrProof").click();
  }

  readFilesURL(files: Event, label): void {
    if (label === 'idProof') {
      if (files && files[0]) {
        this.idProofFile = files[0];
        const reader = new FileReader();
        reader.onload = e => {
          this.idProofPreviewUrl = reader.result;
          console.log("Reader result", reader.result);
        }
        reader.readAsDataURL(this.idProofFile);
      }
    } else {
      if (files && files[0]) {
        this.addrProofFIle = files[0];
        const reader = new FileReader();
        reader.onload = e => {
          this.addrProofPreviewUrl = reader.result;
          console.log("Reader result", reader.result);
        }
        reader.readAsDataURL(this.addrProofFIle);
      }
    }
  }

  uploadCareKycDocs(docType) {
    let data = {
      proposalNo: this.proposalNumber,
      docType: docType
    }
    if (docType === "Identity Proof") {
      data["docFile"] = this.idProofFile;
    } else {
      data["docFile"] = this.addrProofFIle;
    }
    console.log("doc data", data);
    this.loader.showLoader();
    this.apiService.uploadCareOvdKycDocs(data).subscribe(res => {
      this.loader.hideLoader();
      if (docType === "Address Proof") {
        this.healthConditionalObj.showSuccessMsg = true;
        this.showCareOvdkycDocsUpload = false;
        this.toast.showToast("Address Proof Uploaded Successfully!")
      } else {
        this.toast.showToast("Indentity Proof Uploaded Successfully!")
        this.showIdProofCard = false;
      }
    }, err => {
      this.loader.hideLoader();
      console.log("err", err);
    })
  }


}

function dobValidate(control: AbstractControl) {
  const qt_dob: string = control.value;
  const today = new Date();
  let dobInput = new Date(qt_dob);
  var d = new Date();
  d.setMonth(d.getMonth() - 3);
  if (dobInput < d) {
    let age = today.getFullYear() - dobInput.getFullYear();
    let ageday = today.getDate() - dobInput.getDate();
    let m = today.getMonth() - dobInput.getMonth();
    let nowDay = today.getDate()
    let dobDay = dobInput.getDate()
    if (m <= 0) {
      age--;
      m = (12 + m)
    }
    if (nowDay < dobDay) {
      m--;
      ageday = 31 + ageday;
    }
    if (m == 12) {
      age = age + 1;
      m = 0;
    }
    if (age < 18 || age == NaN || age >= 100 && m >= 0 && ageday >= 0) {
      return { 'dobError': true };
    } else {
      return null;
    }

  } else {
    return { 'dobError': true };
  }

}

function dobValidate2(control: AbstractControl) {
  const qt_dob: string = control.value;
  const today = new Date();
  let dobInput = new Date(qt_dob);
  var d = new Date();
  d.setMonth(d.getMonth() - 3);
  if (dobInput < d) {
    let age = today.getFullYear() - dobInput.getFullYear();
    console.log('pppp', today.getDate(), dobInput.getDate())
    let ageday = today.getDate() - dobInput.getDate();
    let m = today.getMonth() - dobInput.getMonth();
    let nowDay = today.getDate()
    let dobDay = dobInput.getDate()
    if (m <= 0) {
      age--;
      m = (12 + m)
    }
    if (nowDay < dobDay) {
      m--;
      ageday = 31 + ageday;
    }
    if (m == 12) {
      age = age + 1;
      m = 0;
    }
    if (age == NaN || age >= 25 && m >= 0 && ageday >= 0) {
      return { 'dobError': true };
    } else {
      return null;
    }

  } else {
    return { 'dobError': true };
  }
  // } else {
  //   console.log("dddd", dobInput > d,d)
  //   return { 'dobError': true };
  // }

}